import { action } from 'typesafe-actions'
import { EstimatesActionTypes, EstimateData, IEstimate } from './types'

export const createEstimateRequest = () =>
  action(EstimatesActionTypes.CREATE_ESTIMATE_REQUEST)

export const createEstimateSuccess = (estimate: {
  email: string
  phoneNumber: string
  firstName: string
  lastName: string
}) => action(EstimatesActionTypes.CREATE_ESTIMATE_SUCCESS, { estimate })

export const createEstimateFail = (message: string) =>
  action(EstimatesActionTypes.CREATE_ESTIMATE_FAIL, message)

export const createPublicEstimateRequest = () =>
  action(EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_REQUEST)

export const createPublicEstimateSuccess = (estimate: {
  email: string
  phoneNumber: string
  firstName: string
  lastName: string
}) => action(EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_SUCCESS, { estimate })

export const createPublicEstimateFail = (message: string) =>
  action(EstimatesActionTypes.CREATE_PUBLIC_ESTIMATE_FAIL, message)

export const fetchEstimatesRequest = () =>
  action(EstimatesActionTypes.FETCH_ESTIMATES_REQUEST)

export const fetchEstimatesSuccess = (estimates: EstimateData) =>
  action(EstimatesActionTypes.FETCH_ESTIMATES_SUCCESS, estimates)

export const fetchEstimatesFail = (message: string) =>
  action(EstimatesActionTypes.FETCH_ESTIMATES_FAIL, message)

export const fetchEstimateRequest = () =>
  action(EstimatesActionTypes.FETCH_ESTIMATE_REQUEST)

export const fetchEstimateSuccess = (estimates: IEstimate) =>
  action(EstimatesActionTypes.FETCH_ESTIMATE_SUCCESS, estimates)

export const fetchEstimateFail = (message: string) =>
  action(EstimatesActionTypes.FETCH_ESTIMATE_FAIL, message)

export const getPDFRequest = () => action(EstimatesActionTypes.GET_PDF_REQUEST)

export const getPDFSuccess = () => action(EstimatesActionTypes.GET_PDF_SUCCESS)

export const getPDFFail = (message: string) =>
  action(EstimatesActionTypes.GET_PDF_FAIL, message)

export const getPDFOnEmailRequest = () =>
  action(EstimatesActionTypes.GET_PDF_ON_EMAIL_REQUEST)

export const getPDFOnEmailSuccess = (pdf: string) =>
  action(EstimatesActionTypes.GET_PDF_ON_EMAIL_SUCCESS, pdf)

export const getPDFOnEmailFail = (message: string) =>
  action(EstimatesActionTypes.GET_PDF_ON_EMAIL_FAIL, message)
